"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readPoleForm = readPoleForm;
exports.readSpanForm = readSpanForm;
const __1 = require("..");
const SpanSubForm_1 = require("./SpanSubForm");
/**
 * Returns an IPoleForm for the given form if it is a Base Form or PLA Form, or null if it is neither.
 */
function readPoleForm(form) {
    if (__1.BaseForm.isBaseForm(form)) {
        return new __1.BaseForm(form);
    }
    if (__1.PLAForm.isPLAForm(form)) {
        return new __1.PLAForm(form);
    }
    return null;
}
function readSpanForm(form) {
    if (__1.BaseForm.isBaseForm(form)) {
        return new __1.BaseForm(form);
    }
    if (__1.PLAForm.isPLAForm(form)) {
        return new __1.PLAForm(form);
    }
    if (form.spanSubForm) {
        return new SpanSubForm_1.SpanSubForm(form.spanSubForm);
    }
    return null;
}
//# sourceMappingURL=IPoleForm.js.map